import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MenuService } from '../../services/menu.service';
import MenuItem from '../../shared/interfaces/menuItems.interface';

@Component({
  selector: 'hdi-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page.component.html',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class PageComponent implements OnInit {
  @Input() mainMenu: Array<MenuItem> = [];

  constructor(private readonly menuService: MenuService) {}

  ngOnInit(): void {
    this.menuService.mainMenu$.subscribe((menu) => {
      this.mainMenu = menu;
    });
  }
}
